import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchCompanyDetails } from '../actions/companyActions'

const useFetchingCompanyDetails = (id, page, pageSize, sortField, sortOrder) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchCompanyDetails(id, true, page, pageSize, sortField, sortOrder))
  }, [dispatch, id])
}

export default useFetchingCompanyDetails
